import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAuction } from '../../myvehicles/MyVehiclesActions';
import AuctionDetailsItem from '../../common/components/Auction/AuctionDetailsItem';
import { auctionListType } from '../../constants/AuctionListType';
import { SSE_BUYER, SSEClient } from '../../api/SSEClient';
import AddVehicleConfirmPage from '../../addvehicle/AddVehicleConfirmPage';
import { AccountLayoutNavItem } from '../../common/components/AccountLayoutWrapper';
import { scrollToElement } from '../../common/helpers/generalHelper';

const SearchDetailsPage = ({ history, location }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const sseClient = new SSEClient(SSE_BUYER);

  const [item, setItem] = useState(null);
  const [step, setStep] = useState(1);
  const [isRepublish, setIsRepublish] = useState(false);
  const [auctionTimeStamp, setAuctionTimestamp] = useState(null);

  useEffect(() => {
    setAuctionTimestamp(new Date());
    dispatch(
      getAuction(id, auction => {
        setItem(auction);
      }),
    );
  }, [dispatch, id]);

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        history.location.state = {
          ...location.state,
          auctionId: id,
        };
      }
    };
  }, [id, history, location]);

  const handleGetAuction = auction => {
    setAuctionTimestamp(new Date());
    if (auction) {
      setItem(auction);
    } else {
      dispatch(
        getAuction(id, auction => {
          setItem(auction);
        }),
      );
    }
  };

  const onNavItemClick = (e, id) => {
    e.preventDefault();
    scrollToElement(id);
  };

  const navItems = useCallback(() => {
    return [
      <AccountLayoutNavItem
        link="#vehicle-details-info"
        onClick={e => onNavItemClick(e, 'vehicle-details-info')}
        className="scroller"
      >
        PHOTOS & INFO
      </AccountLayoutNavItem>,
      <AccountLayoutNavItem
        link="#vehicle-details-specification"
        onClick={e => onNavItemClick(e, 'vehicle-details-specification')}
        className="scroller"
      >
        SPECIFICATION
      </AccountLayoutNavItem>,
      <AccountLayoutNavItem
        link="#vehicle-details-service-history"
        onClick={e => onNavItemClick(e, 'vehicle-details-service-history')}
        className="scroller"
      >
        SERVICE HISTORY
      </AccountLayoutNavItem>,
      <AccountLayoutNavItem
        link="#vehicle-details-description"
        onClick={e => onNavItemClick(e, 'vehicle-details-description')}
        className="scroller"
      >
        DESCRIPTION
      </AccountLayoutNavItem>,
    ];
  }, []);

  const prevStep = () => {
    setStep(prevState => prevState - 1);
  };

  const nextStep = () => {
    setStep(prevState => prevState + 1);
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          item && (
            <AuctionDetailsItem
              item={item}
              listType={auctionListType.SEARCH}
              refreshItem={handleGetAuction}
              sseClient={sseClient}
              typeSseClient={SSE_BUYER}
              nextStep={nextStep}
              setIsRepublish={setIsRepublish}
              auctionTimestamp={auctionTimeStamp}
              inWrapper={true}
              wrapperProps={{
                navOptions: navItems(),
              }}
            />
          )
        );
      case 2:
        return (
          <AddVehicleConfirmPage
            item={item}
            prevStep={prevStep}
            nextStep={nextStep}
            isRepublish={isRepublish}
            refreshItem={handleGetAuction}
          />
        );
      default:
        return null;
    }
  };

  return renderStep();
};

SearchDetailsPage.propTypes = {
  //
};

export default SearchDetailsPage;
